import React from "react";
import styles from "./styles/style.module.scss";

const NotFound = () => {
    return (
        <>
            <section className={styles["not-found"]}>
                <div className="text-center">
                    <div className="four_zero_four_bg">
                        <h1 className="text-center ">404</h1>
                        <div className="contant_box_404">
                            <h3 className="h2">Looks like you are lost</h3>
                            <p>the page you are looking for is not available</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NotFound;
